import { LogisticsEstimateWithAccountInfo } from '@lune-fe/dapi-models'
import { EstimateCreationSourceChip } from '@lune-fe/lune-components-lib'
import { TableNew } from '@lune-fe/lune-ui-lib'
import moment from 'moment'
import { FC, RefObject } from 'react'

import { formatNumberWithFallback } from 'utils'
import {
    EmissionCalculationRow,
    EstimateTypeName,
    EstimateTypeSlug,
    LogisticsEmissionCalculationContextMenu,
} from 'views/CalculateEmissions/index'

const LogisticsEmissionCalculationRow: FC<{
    calculation: LogisticsEstimateWithAccountInfo
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
}> = ({ calculation, currentPage, pageHistoryRef, queryParams }) => {
    const formatDate = (date: string) => {
        return moment(date).format('ll')
    }
    const slug = EstimateTypeSlug(calculation.estimateType)

    return (
        <EmissionCalculationRow
            id={calculation.id}
            slug={slug}
            emissionType={EstimateTypeName(calculation.estimateType)}
            estimateType={calculation.estimateType}
            contextMenu={
                <LogisticsEmissionCalculationContextMenu
                    calculation={calculation}
                    // only simplified shipping estimates are editable via dashboard
                    // we don't have multi-leg shipping create/edit flow on the dashboard
                    editable={slug !== undefined && calculation.estimateType === 'shipping'}
                />
            }
            currentPage={currentPage}
            pageHistoryRef={pageHistoryRef}
            queryParams={queryParams}
        >
            <TableNew.TableCell colSize={2} oneLineText>
                {calculation.source ?? '--'}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {calculation.destination ?? '--'}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {formatDate(calculation.createdAt)}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={1} oneLineText>
                <EstimateCreationSourceChip
                    creationSource={calculation.creationSource}
                    filename={null}
                />
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {calculation.accountName}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1} oneLineText>
                {calculation.numberOfShippingLegs}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1} oneLineText>
                {formatNumberWithFallback(calculation.quantity, {
                    decimals: 2,
                    decimalsWhenLessThan: 6,
                    fallback: '--',
                })}
            </TableNew.TableCell>
        </EmissionCalculationRow>
    )
}

export default LogisticsEmissionCalculationRow
